const RECEIVABLE_AMOUNT_EPSILON = 0.01;

export const isReceivableSettled = (amount: number, linkedAmount: number) => {
  if (amount < 0) {
    return linkedAmount <= amount + RECEIVABLE_AMOUNT_EPSILON;
  }
  return linkedAmount + RECEIVABLE_AMOUNT_EPSILON >= amount;
};

export const getReceivableRemainingAmount = (amount: number, linkedAmount: number) => {
  if (isReceivableSettled(amount, linkedAmount)) {
    return 0;
  }
  return amount - linkedAmount;
};

